import { IconUserCircle as AccountIcon } from '@tabler/icons-react';

const host = process.env.NEXT_PUBLIC_HOST_NAME ?? 'www.tempcover.com';
const loginURI = process.env.NEXT_PUBLIC_DRIVE_URL + '/log-in';

interface AccountIconButtonProps {
  size?: number;
  text?: string;
  className?: string;
  showTextSm?: boolean;
}

export const AccountIconButton = ({
  text = 'Sign in',
  size = 32,
  className = 'text-primary hover:text-dark',
  showTextSm = true,
}: AccountIconButtonProps) => {
  const classes = 'flex items-center gap-1' + ' ' + className;
  return (
    <div className={classes}>
      <div className={`text-base whitespace-nowrap ${!showTextSm ? 'hidden md:block' : ''}`}>{text}</div>
      <AccountIcon size={size} stroke={1.5} />
    </div>
  );
};

export const SignInButton = (props: AccountIconButtonProps) => {
  return (
    <a
      aria-label="Sign in"
      href={`${loginURI}?redirectUrl=${encodeURIComponent(host ?? '')}&flow=login&entry_point=account_icon_homepage`}
      onClick={(e) => {
        e.preventDefault();
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'amplitude_event',
          event_name: 'account_nav_interaction',
          event_properties: {
            action: 'account_icon_clicked',
            path: window.location.pathname,
          },
        });
        const pathname = window.location.pathname;
        const entryPoint = pathname === '/' ? 'account_icon_homepage' : `account_icon_${pathname}`;
        window.location.href = `${loginURI}?redirectUrl=${encodeURIComponent(window.location.href)}&flow=login&entry_point=${encodeURIComponent(entryPoint)}`;
      }}
    >
      <AccountIconButton text="Sign in" {...props} />
    </a>
  );
};

export const SignOutButton = (props: AccountIconButtonProps) => {
  return (
    <form action="/builder-home-rebrand/api/auth/logout" method="post" className="text-left">
      <button
        aria-label="Account menu"
        className="cursor-pointer"
        type="submit"
        onClick={() => {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'amplitude_event',
            event_name: 'account_nav_interaction',
            event_properties: {
              action: 'sign_out_clicked',
              path: window.location.pathname,
            },
          });
        }}
      >
        <AccountIconButton text="Sign out" {...props} />
      </button>
    </form>
  );
};
